const s = document.createElement('script');
s.src = 'https://use.typekit.net/zee2bud.js';
s.onload = () => {
  try {
    Typekit.load();
  } catch (e) {}
};
document.body.appendChild(s);

export default null;
